import React from 'react';

import generatePassword from 'password-generator';
import copy from 'copy-to-clipboard';

// components
import FeedbackBar from "../../feedbackBar/FeedbackBar";

// styling
import './ManageExpandEdit.css';

// material components
import {
    Button,
    TextField,
    FormLabel,
    FormGroup,
    Checkbox,
} from "@material-ui/core";

// constants
import {
    SELECT_SERVICES,
    PASSWORD_ACTION,
    PASSWORD_SUCCESS_MESSAGE,
    SAVE_ACTION,
    CANCEL,
    SAVING,
    SUCCESS,
    ROLE_DEPTH_AND_ORDER,
    ROLE_DASHBOARD,
    ROLE_ADMIN,
    PARENT_ROLE_MAP,
    CHILD_ROLE_MAP,
    TIME_ZONE, SELECT_FOLDER_SERVICES,
} from "./constants";

import PropTypes from "prop-types";
import { Autocomplete } from '@material-ui/lab';
import axios from "axios";
import {BASE_URL} from "../../global/Server/endpoints";

class ManageExpandEdit extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            displayName: '',
            username: '',
            firstname: '',
            lastname: '',
            authorities: [],
            password: '',
            copied: false,
            timezone: '',
            employeePerHour: '',
            employeeColor: '',
            userId: '',
            serverMessage: '',
            isServerMessage: false,
            isDialog: false,
            dashboardFolders: [],
            selectedFolders : []
        }
    }

    async componentDidMount() {

         this.fetchDashboardFolders();


        const authorities = this.props.user.authorities.map(authority => {
            return authority.authority
        })
        let newAuthorities = new Set(authorities)
        if (!newAuthorities.has(ROLE_ADMIN)) {
            newAuthorities.add(ROLE_DASHBOARD)
        }
        this.setState({
            displayName: this.props.user.displayName,
            username: this.props.user.username,
            authorities: Array.from(newAuthorities),
            firstname: this.props.user.firstname,
            employeePerHour: this.props.user.employeePerHour,
            employeeColor: this.props.user.employeeColor,
            lastname: this.props.user.lastname,
            timezone: this.props.user.timezone,
            userId: this.props.user?.userId,
            selectedFolders: this.props.user?.selectedFolders
        })
    }

    fetchDashboardFolders = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${BASE_URL}/dashboardFolder/list`,
                { companyId: this.props.user.companyId
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.success) {
                this.setState({ dashboardFolders: res.data.data });
            } else {
                this.openFeedback("error", res.data.message || "Failed to load folders");
            }
        } catch (e) {
            console.error("Fetch error:", e);
            this.openFeedback("error", "Server error while fetching folders");
        }
    };


    handleEdit = (value, name) => {
        this.setState({
                [name]: value
            })
    }


    createPassword = () => {
        const newPassword = generatePassword(16, false, /[\d\W\w\p]/g).toString()
        this.setState({
            password: newPassword,
            copied: true
        })
        copy(newPassword)
    }

    selectAuthority = (role) => {
        if (role === ROLE_ADMIN) {
            if (this.state.authorities.includes(role)) {
                this.setState({
                    authorities: [ROLE_DASHBOARD]
                })
            } else {
                this.setState({
                    authorities: [ROLE_ADMIN]
                })
            }
            return
        }

        let newAuthority = new Set(this.state.authorities)
        const updateChild = (isDelete, role) => {
            if (isDelete) {
                if (PARENT_ROLE_MAP[role]) {
                    PARENT_ROLE_MAP[role].forEach(child => {
                        newAuthority.delete(child)
                    })
                }
                if (CHILD_ROLE_MAP[role]) {
                    CHILD_ROLE_MAP[role].forEach(parent => {
                        let hasChild = false
                        PARENT_ROLE_MAP[parent].forEach(child => {
                            if (newAuthority.has(child)) {
                                hasChild = true
                            }
                        })
                        if (!hasChild) {
                            newAuthority.delete(parent)
                        }
                    })
                }
            } else {
                if (PARENT_ROLE_MAP[role]) {
                    PARENT_ROLE_MAP[role].forEach(child => {
                        newAuthority.add(child)
                    })
                }
                if (CHILD_ROLE_MAP[role]) {
                    CHILD_ROLE_MAP[role].forEach(parent => {
                        newAuthority.add(parent)
                    })
                }
            }
        }
        if (!this.state.authorities.includes(role)) {
            this.props.allRoles.forEach(roleInAllRole => {
                if (role === roleInAllRole) {
                    newAuthority.add(roleInAllRole)
                    updateChild(false, roleInAllRole)
                }
                if (this.state.authorities.includes(roleInAllRole)) {
                    newAuthority.add(roleInAllRole)
                }
            });
        } else {
            newAuthority.delete(role)
            updateChild(true, role)
        }

        this.setState({
            authorities: Array.from(newAuthority)
        })
    }

    saveChanges = () => {
        const isNewPassword = this.state.password.length > 0
        const data = {
            admin: this.props.admin.username,
            authorities: this.state.authorities,
            change_password: isNewPassword,
            password: this.state.password?.length > 0 ? this.state.password : null,
            firstname: this.state.firstname,
            employeePerHour: this.state.employeePerHour,
            employeeColor: this.state.employeeColor,
            lastname: this.state.lastname,
            new_displayname: this.state.displayName,
            user_to_change: this.props.user.username,
            timezone: this.state.timezone,
            selectedFolders: this.state.selectedFolders

        }


        const userInfoToPost = {
            ...this.props.admin,
        }
        this.props.editUser(data, userInfoToPost, this.props.handleOpen)
        this.props.handleClose()
    }

    handlePasswordMessageClose = () => {
        this.setState({ copied: false })
    }

    handleServerMessageClose = () => {
        this.setState({ isServerMessage: false })
    }

    getChecked = (role) => {
        return this.state.authorities.includes(role)
    }


    getLabel = (label) => {
        let words = label.split('_')
        words.splice(0, 1)
        words = words.map(word => {
            return word[0].toUpperCase() + word.slice(1).toLowerCase()
        })
        return words.join(' ')
    }

    getSpace = (role) => {
        let spaces = []
        for (let index = 0; index < ROLE_DEPTH_AND_ORDER[role]; index++) {
            spaces.push("space")
        }
        return spaces.map(space => {
            return <div className="authority-space" />
        })
    }

    isChecked = (folderId) => {
        const { selectedFolders } = this.state;
        return Array.isArray(selectedFolders) && selectedFolders.includes(folderId);
    };

    toggleFolderSelection = (folderId) => {
        this.setState((prevState) => {
            // Make sure selectedFolders is always an array
            const selectedFolders = Array.isArray(prevState.selectedFolders)
                ? prevState.selectedFolders
                : [];

            return {
                selectedFolders: selectedFolders.includes(folderId)
                    ? selectedFolders.filter((id) => id !== folderId)
                    : [...selectedFolders, folderId],
            };
        });
    };

    render() {
        const { dashboardFolders } = this.state;
        return (
          <div className="row-register-new-user" style={{ marginTop: '40px' }}>
            <FeedbackBar
              open={this.state.copied}
              severity={SUCCESS}
              message={PASSWORD_SUCCESS_MESSAGE}
              handleClose={this.handlePasswordMessageClose}
            />

            <FeedbackBar
              open={this.state.isServerMessage}
              severity={SUCCESS}
              message={this.state.serverMessage}
              handleClose={this.handleServerMessageClose}
            />

            <div className="rowSpec">
              <TextField
                disabled
                className="register-new-user-Input"
                variant="outlined"
                label="Email Address"
                InputLabelProps={{ shrink: true }}
                name="username"
                value={this.state.username}
                onChange={this.handleChange}
              />
            </div>
            <div className="rowSpec">
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="First Name"
                InputLabelProps={{ shrink: true }}
                name="firstname"
                value={this.state.firstname}
                onChange={(e) => this.handleEdit(e.target.value, e.target.name)}
              />
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Last Name"
                InputLabelProps={{ shrink: true }}
                name="lastname"
                value={this.state.lastname}
                onChange={(e) => this.handleEdit(e.target.value, e.target.name)}
              />
            </div>
            <div className="rowSpec">
              <TextField
                disabled
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Display Name"
                InputLabelProps={{ shrink: true }}
                name="displayName"
                value={`${this.state.firstname} ${this.state.lastname  || ""}`}
              />
              <Autocomplete
                options={TIME_ZONE}
                getOptionLabel={(entry) => entry}
                autoHighlight={true}
                className="register-new-user-TwoInput"
                value={this.state.timezone}
                onChange={(event, value) => {
                  this.handleEdit(value, 'timezone');
                }}
                name="timezone"
                blurOnSelect={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Time zone"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="timezone"
                  />
                )}
              />
            </div>
            <div className="rowSpec">
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Password"
                InputLabelProps={{ shrink: true }}
                name="password"
                type="password"
                onChange={(e) => {
                  this.setState({ password: e.target.value });
                }}
                value={this.state.password}
                autoComplete="new-password"
              />
              <Button
                className="register-new-user-TwoInput"
                value={this.state.password}
                color="secondary"
                variant="contained"
                onClick={() => {
                  this.createPassword();
                }}
              >
                {PASSWORD_ACTION}
              </Button>
            </div>

            <div className="rowSpec">
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Employee Per Hour Rate"
                InputLabelProps={{ shrink: true }}
                name="employeePerHour"
                value={this.state.employeePerHour}
                onChange={(e) => this.handleEdit(e.target.value, e.target.name)}
                type="number"
              />

              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Employee Color"
                InputLabelProps={{ shrink: true }}
                name="employeeColor"
                value={this.state.employeeColor}
                onChange={(e) => this.handleEdit(e.target.value, e.target.name)}
              />
            </div>


                {/* Register Button */}


              <div className="register-new-user-role-box">
                  <FormLabel component="legend">{SELECT_FOLDER_SERVICES}</FormLabel>
                  <FormGroup>
                      {dashboardFolders.map((folder) => (
                          <div key={folder.dashboardFolderId} className="authority-box">
                              <Checkbox
                                  checked={this.isChecked(folder.dashboardFolderId)}
                                  onChange={() => this.toggleFolderSelection(folder.dashboardFolderId)}
                                  color="primary"
                              />
                              <div className="authority-text">{folder.title}</div>
                          </div>
                      ))}
                  </FormGroup>
              </div>




                <div className="register-new-user-role-box">
                    <FormLabel component="legend">{SELECT_SERVICES}</FormLabel>
                    <FormGroup>
                        {this.props.allRoles.map((role, i) => {
                            return (
                                <div className="authority-box">
                                    {this.getSpace(role)}
                                    <Checkbox
                                        disabled={
                                            role === ROLE_DASHBOARD ||
                                            this.state.authorities.includes(ROLE_ADMIN)
                                        }
                                        checked={this.getChecked(role)}
                                        onChange={() => this.selectAuthority(role)}
                                        name="authority"
                                        color="primary"
                                    />
                                    <div
                                        className={
                                            role === ROLE_DASHBOARD ||
                                            this.state.authorities.includes(ROLE_ADMIN)
                                                ? 'authority-text-disabled'
                                                : ''
                                        }
                                    >
                                        {this.getLabel(role) === 'Manage Users'
                                            ? 'Manage Employees'
                                            : this.getLabel(role)}
                                    </div>
                                </div>
                            );
                        })}
                        <div className="authority-box">
                            {this.getSpace(ROLE_ADMIN)}
                            <Checkbox
                                checked={this.getChecked(ROLE_ADMIN)}
                                onChange={() => this.selectAuthority(ROLE_ADMIN)}
                                name="authority"
                                color="primary"
                            />
                            <div className="authority-text">
                                {this.getLabel(ROLE_ADMIN)}
                            </div>
                        </div>
                    </FormGroup>
                </div>
                <div style={{marginBottom:'20px'}}>
                    <Button
                        variant="outlined"
                        onClick={this.props.handleClose}
                        className="register-new-user_btn"
                    >
                        {CANCEL}
                    </Button>
                    <Button
                        className="register-new-user_btn"
                        variant="contained"
                        color="primary"
                        onClick={() => this.saveChanges()}
                        // disabled={!(this.state.password && this.state.password.length > 0)}
                    >
                        {this.props.loading ? SAVING : SAVE_ACTION}
                    </Button>
                </div>

                </div>
            );
            }

              }

                ManageExpandEdit.propTypes = {
                isEdit: PropTypes.bool,
                user: PropTypes.object,
                admin: PropTypes.func,
                editUser: PropTypes.func,
                status: PropTypes.number,
                statusMessage: PropTypes.string,
                loading: PropTypes.bool,
                open: PropTypes.bool,
                success: PropTypes.bool,
                handleClose: PropTypes.func,
                handleOpen: PropTypes.func,
            }

                ManageExpandEdit.defaultProps = {
                isEdit: false,
                user: {},
                admin: () => {},
                editUser: () => {},
                status: 404,
                statusMessage: "",
                loading: false,
                open: false,
                success: false,
                handleClose: () => {},
                handleOpen: () => {},
            }
            export default ManageExpandEdit;